import { cloneElement } from 'react';
import classnames from 'classnames';

import { CustomCursor } from 'components/custom-cursor/CustomCursor';
import { H3 } from 'components/heading/Heading';
import { Link } from 'components/link/Link';
import { IconChevron } from 'components/icon/Icon';

import s from './PartyProfileCard.module.scss';
import { useIntl } from 'react-intl';

const c = classnames.bind(s);

type Props = {
  title: string;
  image?: React.ReactElement;
  link?: string;
};

export const PartyProfileCard = ({ image, title, link }: Props) => {
  const { formatMessage } = useIntl();
  if (!title || !link) {
    return null;
  }
  // Split the title into staffname and stafftitle
  const [staffName, staffTitle] = title.split(',').map((str) => str.trim());
  const staffTitleCapitalized =
    staffTitle?.charAt(0).toUpperCase() + staffTitle?.slice(1);

  return (
    <Link className={c(s.wrapper)} to={link}>
      {image &&
        cloneElement(image, {
          className: s.image,
        })}
      <CustomCursor className={s.customCursor}>
        {formatMessage({
          id: 'view_profile',
          defaultMessage: 'Skoða',
        })}
        <IconChevron />
      </CustomCursor>
      <div className={s.content}>
        <div className={s.overlay}></div>
        <div className={s.overlayHover}></div>
        <div className={s.overlayPress}></div>
        <div className={s.info}>
          <H3 className={s.infoName} skipGradient>
            {staffName}
          </H3>
          <H3 className={s.infoTitle} skipGradient>
            {staffTitleCapitalized}
          </H3>
        </div>
      </div>
    </Link>
  );
};
